import React from "react";
import { useLanguage } from "../../../../contexts";
import "../RiskMatrixGuide/RiskMatrixGuide.scss";

export function LeopoldGuide() {
  const { translations } = useLanguage();
  const t = (key) => translations[key] || key;

  return (
    <div className="risk-matrix-guide">
      <h2>{t("risk_matrix_leopold_guide_title")}</h2>
      <p>{t("risk_matrix_leopold_guide_intro")}</p>
      <ol>
        <li>{t("risk_matrix_leopold_guide_step1")}</li>
        <li>{t("risk_matrix_leopold_guide_step2")}</li>
        <li>{t("risk_matrix_leopold_guide_step3")}</li>
        <li>{t("risk_matrix_leopold_guide_step4")}</li>
      </ol>

      <div className="risk-matrix-guide__note">{t("risk_matrix_leopold_guide_auto_note")}</div>

      <h3>{t("risk_matrix_guide_criteria_title")}</h3>
      <table className="risk-matrix-guide__table">
        <thead>
          <tr>
            <th>{t("risk_matrix_guide_criteria_component")}</th>
            <th>{t("risk_matrix_guide_criteria_scale")}</th>
            <th>{t("risk_matrix_leopold_guide_what_col")}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{t("risk_matrix_leopold_magnitude")}</td>
            <td>−10 … +10</td>
            <td>{t("risk_matrix_leopold_guide_magnitude_use")}</td>
          </tr>
          <tr>
            <td>{t("risk_matrix_leopold_importance")}</td>
            <td>1 … 10</td>
            <td>{t("risk_matrix_leopold_guide_importance_use")}</td>
          </tr>
        </tbody>
      </table>

      <div className="risk-matrix-guide__ref">{t("risk_matrix_leopold_guide_traceability")}</div>
    </div>
  );
}
